export default {
  noDashboards: 'Pre {asset} nie sú dostupné žiadne panely.',
  noWidgets: 'Pre {dashboard} nie sú dostupné žiadne widgety.',
  addDashboard: 'Vytvoriť panel',
  addWidget: 'Pridať widget',
};
